import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ManagePagesLoader } from '@confluence/manage-pages/entry-points/ManagePagesLoader.tsx';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';
import { DocumentContentTitle } from '@confluence/document-title/entry-points/DocumentContentTitle.ts';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceBulkToolsRoute: {
	({ params: { spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { spaceKey } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
			};
			pageState: {
				routeName: string;
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
		};
	};
} = ({ params: { spaceKey } }: RouteMatch): React.JSX.Element => {
	if (isCompanyHubSpaceKey(spaceKey)) {
		return (
			<>
				<DocumentContentTitle notFound />
				<NotFound />
			</>
		);
	}

	return (
		<SpaceBase>
			<ManagePagesLoader spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceBulkToolsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
		};
		pageState: {
			routeName: string;
			spaceKey: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'spaceBulkTools', id: spaceKey },
		pageState: { routeName: name, spaceKey },
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
	},
});
